<div class="full-page w-100 d-flex">
  <!--Left Side-->
  <div class="left-side-login">
    <img
      class="shared-login-banner"
      draggable="false"
      src="/assets/images/club-logo.png"
      alt="chicago sky banner"
    />
  </div>
  <!--Right Side-->
  <div class="right-side-login">
    <div class="right-side-container text-center">
      <div class="maintenance-icon text-primary icon material-icons">engineering</div>
      <h5 class="title text-primary my-1 fw-bold" [innerHTML]="'maintenance.page.title' | translate | markdownTranslate"></h5>
      <div class="font-size-14" [innerHTML]="'maintenance.page.details' | translate | markdownTranslate"></div>
    </div>
  </div>
</div>
